/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Router from "vue-router";
import { checkQuizNeeded } from "@/utils/quizCheck";

// Routes
import paths from "./paths";

function route(path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta,
    component: (resolve) => {
      import(`@/views/${view}.vue`).then((mode) => resolve(mode.default));
    },
  };
}

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: "history",
  base: process.env.NODE_ENV == "production" ? "/app/" : "/",
  routes: paths
    .map((path) => route(path.path, path.view, path.name, path.meta))
    .concat([{ path: "*", redirect: "/dashboard" }]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.name == "Login") {
    next();
    return;
  }

  const authToken = localStorage.getItem("auth-token");
  
  if (to.meta.layout == "view-auth") {
    if (authToken === null && to.name === "Quiz") {
      next("/login");
      return;
    }
    
    if (authToken !== null && to.name !== "Logout" && to.name !== "Quiz") {
      next("/dashboard");
      return;
    }
    
    // Если пользователь авторизован и пытается попасть на Quiz
    if (authToken !== null && to.name === "Quiz") {
      try {
        const { needed, redirect } = await checkQuizNeeded();
        if (!needed && redirect) {
          next(redirect);
          return;
        }
      } catch (error) {
        console.error('Error checking quiz:', error);
        next("/dashboard");
        return;
      }
    }
    
    next();
  } else if (authToken !== null) {
    // Проверяем квиз только для dashboard, чтобы не блокировать другие роуты
    if (to.name === "Dashboard") {
      try {
        const { needed, redirect } = await checkQuizNeeded();
        if (needed && redirect === null) {
          next("/quiz");
          return;
        }
      } catch (error) {
        console.error('Error checking quiz:', error);
      }
    }
    next();
  } else {
    next("/login");
  }
});

router.afterEach((to) => {
  if (localStorage.getItem("auth-token") === null || to.name === "Quiz") {
    window.tidioChatApi &&
      window.tidioChatApi.display(false);
  }
});

export default router;
